import { Fragment } from 'react';
import { OverflowLite } from '@sas/react-svg';
import cx from 'classnames';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { Avatar } from '../../Avatar';
import { ButtonVariant } from '../../Button';
import { Heading } from '../../Heading';
import { Icon } from '../../Icon';
import { Link } from '../../Link';
import { MenuButton } from '../../MenuButton';
import { Text } from '../../Text';
import cn from './TileHeader.css.json';
import './TileHeader.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TileHeader = props => {
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars({
    'spacing-xs': dt.tokens['space-inline-xs'],
    'spacing-s': dt.tokens['space-inline-s'],
    'spacing-m': dt.tokens['space-inline-m'],
    'icon-fg': dt.tokens['color-body-text'],
    'icon-size': dt.tokens['size-icon-m'],
    'font-size': dt.tokens['font-size-heading-text-5'],
    'font-size-s': dt.tokens['font-size-body-text-s'],
    'font-weight': dt.tokens['font-style-weight-700']
  }, 'tile-header');
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: cx(cn.container, props.title && props.subTitle && cn.withSubtitle),
      style: tokens,
      children: [props.avatarProps ? /*#__PURE__*/_jsx(Avatar, {
        ...props.avatarProps,
        size: "small",
        testId: postfixTestId(props.testId, 'object-avatar'),
        className: cx(props.avatarProps.className, cn.icon),
        focusable: props.tabIndex === 0 && props.avatarProps.focusable ? true : undefined
      }) : props.icon ? /*#__PURE__*/_jsx(Icon, {
        ...props.icon,
        testId: postfixTestId(props.testId, 'object-icon'),
        className: cx(props.icon.className, cn.icon),
        tabIndex: props.tabIndex === 0 && !props.objectIconAriaHidden ? 0 : undefined,
        theme: () => {
          return {
            '--icon-default-override-fg': 'var(--tile-header-icon-fg)',
            '--icon-neutral-override-fg': 'var(--tile-header-icon-fg)',
            '--icon-alert-override-fg': 'var(--tile-header-icon-fg)',
            '--icon-warning-override-fg': 'var(--tile-header-icon-fg)',
            '--icon-success-override-fg': 'var(--tile-header-icon-fg)',
            '--icon-information-override-fg': 'var(--tile-header-icon-fg)'
          };
        }
      }) : null, props.title ? /*#__PURE__*/_jsxs(Fragment, {
        children: [props.onOpen && !props.suppressTitleAsLink ? /*#__PURE__*/_jsx(Link, {
          id: props.titleId,
          tabIndex: props.tabIndex,
          onPress: () => {
            props.onOpen?.();
          },
          wrapText: false,
          decoration: "hover-only",
          className: cn.title,
          testId: postfixTestId(props.testId, 'link'),
          children: props.title
        }) : /*#__PURE__*/_jsx(Heading, {
          focusable: props.tabIndex === 0,
          id: props.titleId,
          level: 4,
          wrapText: false,
          className: cn.title,
          testId: postfixTestId(props.testId, 'title-heading'),
          children: props.title
        }), props.subTitle ?
        /*#__PURE__*/
        // subTitle is only shown when props.title is provided
        _jsx(Heading, {
          id: `${props.titleId}-subtitle`,
          level: 5,
          focusable: props.tabIndex === 0,
          wrapText: false,
          className: cn.subtitle,
          testId: postfixTestId(props.testId, 'subtitle-heading'),
          children: props.subTitle
        }) : null]
      }) : null, props.menuButtonProps ? /*#__PURE__*/_jsx("div", {
        className: cn.menuButtonContainer,
        children: /*#__PURE__*/_jsx(MenuButton, {
          ...props.menuButtonProps,
          focusable: props.tabIndex === 0,
          hideDownArrow: true,
          variant: ButtonVariant.Icon,
          icon: {
            icon: OverflowLite
          },
          testId: postfixTestId(props.testId, 'menuButton')
        })
      }) : null]
    }), props.description ? /*#__PURE__*/_jsx(Text, {
      id: `${props.titleId}-description`,
      tabIndex: props.tabIndex === 0 ? 0 : undefined,
      testId: postfixTestId(props.testId, 'description'),
      theme: () => ({
        '--text-focus-outline-offset': '0'
      }),
      children: props.description
    }) : null]
  });
};
//# sourceMappingURL=TileHeader.js.map